<template>
  <div class="row">
    <div class="col-xl-12 d-flex">
      <div class="card flex-fill">
        <div class="card-header d-flex align-items-center justify-content-between flex-wrap row-gap-2">
          <h5>Recent Deals</h5>
          <router-link to="/crm/deals-list" class="btn btn-sm btn-light px-3">
            View All
          </router-link>
        </div>

        <div class="card-body p-0">
          <div class="table-responsive">
            <table class="table table-nowrap dashboard-table mb-0">
              <thead>
                <tr>
                  <th>Deal Name</th>
                  <th>Stage</th>
                  <th>Deal Value</th>
                  <th>Owner</th>
                  <th>Expected Close</th>
                </tr>
              </thead>

              <tbody>
                <tr
                  v-for="d in deals"
                  :key="d.id"
                  class="hover-pointer"
                  @click="goDeal(d.id)"
                >
                  <td>
                    <h6 class="fw-medium mb-0">
                      {{ d.name }}
                    </h6>
                  </td>

                  <td>
                    <span class="badge badge-soft-primary">
                      {{ d.stage?.name || "—" }}
                    </span>
                  </td>

                  <td>
                    {{ fmtMoney(d.amount, d.currency) }}
                  </td>

                  <td @click.stop="drillOwner(d.owner?.id)">
                    <div class="d-flex align-items-center">
                      <a href="javascript:void(0);" class="avatar avatar-rounded flex-shrink-0 me-2">
                        <img
                          v-if="d.owner?.avatar_url"
                          :src="d.owner.avatar_url"
                          alt="Img"
                        />
                        <span
                          v-else
                          class="avatar-title rounded-circle bg-primary text-white"
                        >
                          {{ initials(ownerName(d)) }}
                        </span>
                      </a>
                      <h6 class="fw-medium mb-0">
                        {{ ownerName(d) }}
                      </h6>
                    </div>
                  </td>

                  <td>
                    {{ d.expected_close_date || "—" }}
                  </td>
                </tr>

                <tr v-if="!deals.length">
                  <td colspan="5" class="text-center text-muted py-4">
                    No recent deals for selected filters.
                  </td>
                </tr>
              </tbody>
            </table>
          </div>
        </div>

      </div>
    </div>
  </div>
</template>

<script setup>
import { computed } from "vue";
import { useRouter } from "vue-router";
import { useDealDashboardStore } from "@/stores/dealDashboardStore";

const dash = useDealDashboardStore();
const router = useRouter();

const deals = computed(() => dash.recentDeals || []);

function fmtMoney(v, cur = "KES") {
  const n = Number(v || 0);
  return `${cur} ${n.toLocaleString(undefined, { minimumFractionDigits: 2 })}`;
}

function ownerName(d) {
  if (!d.owner) return "—";
  return `${d.owner.first_name || ""} ${d.owner.last_name || ""}`.trim();
}

function initials(name = "") {
  return name
    .split(" ")
    .filter(Boolean)
    .map((x) => x[0])
    .slice(0, 2)
    .join("")
    .toUpperCase();
}

function goDeal(id) {
  router.push(`/crm/deals-details/${id}`);
}

async function drillOwner(ownerId) {
  if (!ownerId) return;
  dash.filters.owner_id = ownerId;
  await dash.fetchDashboard();
}
</script>

<style scoped>
.hover-pointer {
  cursor: pointer;
}
</style>
